import emailjs from "@emailjs/browser";

/** CRA inlines these at build time; trim avoids hidden spaces breaking the API. */
export function getEmailJsPublicKey() {
  return (process.env.REACT_APP_EmailJs_Public_Key || "").trim();
}


export function getEmailJsServiceId() {
  return (process.env.REACT_APP_Email_Service_Id || "").trim();
}

/** Azure `#{name}#` tokens are for pipeline YAML, not valid EmailJS credentials. */
function looksLikeCiPlaceholder(v) {
  return typeof v === "string" && v.includes("#{") && v.includes("}#");
}

export function emailJsEnvLooksMisconfigured() {
  return (
    looksLikeCiPlaceholder(getEmailJsPublicKey()) ||
    looksLikeCiPlaceholder(getEmailJsServiceId())
  );
}

let didInit = false;

export function initEmailJs() {
  if (emailJsEnvLooksMisconfigured()) {
    console.warn(
      "[EmailJS] .env contains #{...}# placeholders. Those are for Azure DevOps token replace only. " +
        "Set real REACT_APP_Email_Service_Id and REACT_APP_EmailJs_Public_Key from https://dashboard.emailjs.com/admin and restart npm start."
    );
  }
  const publicKey = getEmailJsPublicKey();
  if (!publicKey || didInit) return;
  emailjs.init({ publicKey });
  didInit = true;
}

/** Pass on every sendForm so the request always carries the key (avoids stale store). */
export function emailJsSendFormOptions() {
  return { publicKey: getEmailJsPublicKey() };
}
